<template>
  <div id="app">
    <div v-if="isMobile" class="layer">
      <div class="layer-content">
        <svg t="1688973335444" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8010" width="200" height="200"><path d="M997.64736 819.1488l0-0.13824L577.84832 91.89888l-0.07168 0c-5.25312-19.3536-29.25056-33.87392-58.07104-33.87392-29.0304 0-52.94592 14.86848-57.99424 34.432L32.0256 836.608l0.35328 0.49152c-9.82016 9.74848-7.92576 32.89088 5.39648 54.49216 13.39904 22.02624 33.59232 34.29888 46.63808 29.24544l0.49152 0.768 869.75488 0 0.49152-1.11616c14.52032 2.24256 32.39936-10.52672 43.55072-33.24928C1011.74272 861.08672 1010.90304 831.63136 997.64736 819.1488L997.64736 819.1488zM458.83904 320.52224c0-32.18944 26.15808-58.27584 58.27584-58.27584 32.26112 0 58.28096 26.0864 58.28096 58.27584l0 300.36992c0 32.11264-26.01984 58.27584-58.28096 58.27584-32.11776 0-58.27584-26.15808-58.27584-58.27584L458.83904 320.52224 458.83904 320.52224zM517.12 844.81536c-34.9952 0-63.39584-28.40576-63.39584-63.46752 0-35.00032 28.40064-63.26272 63.39584-63.26272 34.9952 0 63.39072 28.26752 63.39072 63.26272C580.51072 816.33792 552.1152 844.81536 517.12 844.81536L517.12 844.81536z" fill="#ffffff" p-id="8011"></path></svg>
        <span class="tips">为了您的最佳体验&nbsp;<br />请开启手机横屏功能</span>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      isMobile: false,
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init() {
      // 判断是否为移动端展示
      if (!(navigator.userAgent.match(/(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) return;
      const matchMedia = window.matchMedia('(orientation: portrait)');
      if (matchMedia && window.screen.width > 600) return; // 排除移动端大屏设备
      const onMatchMediaChange = (m) => {
        this.isMobile = !!m.matches;
      };
      // 监听手机横竖状态，强制横屏状态
      onMatchMediaChange(matchMedia);
      matchMedia.addListener(onMatchMediaChange);
    },
  }
};
</script>
<style lang="scss">
  @import "../static/index.scss";
</style>

<style>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-table .danger-row {
    background: #E4E7ED;
  }
  .el-table .user-prop-row {
    background: black;
    color: #fff;
  }
</style>

<style lang="scss" scoped>
  .layer {
    width: 100%;
    height: 100%;
    color: #ffffff;
    font-size: 20px;
    line-height: 32px;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;

    &-content {
      width: 100%;
      height: 120px;
      margin-top: -20px;
      display: flex;
      justify-content: center;
      align-items: center;
      .icon {
        width: 58px;
        height: 58px;
      }
      .tips {
        margin-left: 16px;
      }
    }
  }
</style>
